const formSetCustomValidity = () => {
    // Validation sur input[type=email]
    document.querySelectorAll('input[type="email"]').forEach(input => {
        input.addEventListener('change', function () {
            if (this.validity.typeMismatch) {
                this.setCustomValidity('Saisie invalide, format attendu : anne.onime@yahoo.fr');
                this.reportValidity();
            } else {
                this.setCustomValidity('');
            }
        });
    });

    // Validation sur input[type=url]
    document.querySelectorAll('input[type="url"]').forEach(input => {
        input.addEventListener('change', function () {
            if (this.validity.typeMismatch) {
                this.setCustomValidity('Saisie invalide, format attendu : https://www.nomdedomaine.com');
                this.reportValidity();
            } else {
                this.setCustomValidity('');
            }
        });
    });

    // Validation sur input[type=file]
    document.querySelectorAll('form').forEach(form => {
        form.addEventListener('change', function () {
            let size = 0;
            let $error = false;
            let $errorBis = false;

            this.querySelectorAll('input[type="file"]').forEach(input => {
                if (input.files.length > 0) {
                    if (input.dataset.maxsize && input.files[0].size > input.dataset.maxsize) {
                        $error = input;
                        return false;
                    }

                    const extension = input.files[0].name.substring(input.files[0].name.lastIndexOf('.')).toLowerCase();
                    if (input.getAttribute('accept') &&
                        !input.getAttribute('accept').includes('*') &&
                        !input.getAttribute('accept').split(', ').includes(extension)) {
                        $errorBis = input;
                        return false;
                    }
                    size += input.files[0].size;
                }

                return true;
            });

            if ($error) {
                let size = $error.dataset.maxsize;
                size = (size < 1000000) ? `${size / Math.pow(2, 10)} Ko` : `${size / Math.pow(2, 20)} Mo`;
                $error.setCustomValidity(`La taille du fichier dépasse ${size}`);
                $error.reportValidity();
                return false;
            }

            if ($errorBis) {
                $errorBis.setCustomValidity(`Extension autorisée parmi "${$errorBis.getAttribute('accept')}"`);
                $errorBis.reportValidity();
                return false;
            }

            if (size > cmsCore.postMaxSize) {
                alert(`La taille totale des fichiers dépasse ${cmsCore.postMaxSize / Math.pow(2, 20)} Mo`);
                return false;
            }

            return true;
        });
    });

    document.querySelectorAll('input[type="file"]').forEach(input => {
        input.addEventListener('change', function () {
            this.setCustomValidity('');
        });
    });
}

document.addEventListener('DOMContentLoaded', formSetCustomValidity);
